'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGroups = undefined;

var _utils = require('./utils');

var getGroups = exports.getGroups = function getGroups(playerSessionID) {
  return (0, _utils.getProtected)('/player-groups', playerSessionID);
};

exports.default = {
  getGroups: getGroups
};